module.exports = __webpack_public_path__ + "static/media/recordingportal.d74056e8.png";